module.exports = __webpack_public_path__ + "img/facebook.377a105b.svg";